"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveQuestion = void 0;
const processDB_1 = require("./processDB");
function moveQuestion(db, qId, destLid, destIdx) {
    var _a, _b;
    const q = db.questions[qId];
    const srcList = db.lists[q === null || q === void 0 ? void 0 : q.parentListId];
    const srcIdx = q === null || q === void 0 ? void 0 : q.parentListIdx;
    const destList = db.lists[destLid];
    const newQ = Object.assign({}, q);
    (0, processDB_1.processQuestion)(db, newQ);
    (_a = srcList === null || srcList === void 0 ? void 0 : srcList.childQIds) === null || _a === void 0 ? void 0 : _a.splice(srcIdx, 1);
    (0, processDB_1.processListParent)(db, srcList);
    (_b = destList === null || destList === void 0 ? void 0 : destList.childQIds) === null || _b === void 0 ? void 0 : _b.splice(destIdx, 0, newQ.qId);
    (0, processDB_1.processListParent)(db, destList);
    return newQ;
}
exports.moveQuestion = moveQuestion;
exports.default = moveQuestion;
